import React from 'react';
import { useSubscriptionsDetails } from '../SubscriptionsDetailsProvider';
import ProductInfo from './SubscriptionInfo';

function SubscriptionsDetailsHeader() {
    const { subscriptionsDetailsData, handleReload, openModal } = useSubscriptionsDetails();
    return (
        <ProductInfo
            data={subscriptionsDetailsData}
            handleReload={handleReload}
            openModal={openModal}
        />
    );
}

export default SubscriptionsDetailsHeader;
